import { createBlueprint as t } from "@made-people/blueprint";
const a = t({
  slots: {
    base: "overflow-x-auto rounded-lg shadow bg-white p-4",
    table: "min-w-full border-collapse",
    header: "",
    heading: "text-lg font-semibold text-gray-800 mb-4 h-full w-full",
    buttonWrapper: "flex justify-center gap-4 mb-4",
    button: "px-4 py-2 text-sm font-medium text-gray-600 bg-gray-200 rounded transition data-[active=true]:bg-gray-800 data-[active=true]:text-white"
  },
  variants: {}
});
export {
  a as sizeGuideTableBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
